import React, { useEffect, useState } from 'react';
import { View, ScrollView } from 'react-native';

import { orderBy as _orderBy, sortBy as _sortBy } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import { DevicesList } from '../../Components';

import styles from './DevicesSelection.Styles';

const DevicesSelection = ({
  isLoading,
  devices,
  onSelectDevicePress,
  isEditMode,
  selectedDevice,
  ...props
}) => {
  const [_devices, setDevices] = useState([]);

  useEffect(() => {
    if (isEditMode) {
      // set the selected device at the first in Edit mode
      setDevices(_sortBy(devices, ({ id }) => (id === selectedDevice?.id ? 0 : 1)));
    } else {
      // set the recomended device at the first
      setDevices(_orderBy(devices, 'isRecommended', 'desc'));
    }
  }, [devices]);

  if (isLoading) {
    return null;
  }

  return (
    <ScrollView style={styles.containerStyle}>
      <View style={styles.headerContainerStyle}>
        <VFText
          i18nKey="device_upgrade_choose_step_header"
          style={styles.headerTextStyle}
          type="primary"
        />
      </View>
      <DevicesList
        devices={_devices}
        onSelectDevicePress={onSelectDevicePress}
        isEditMode={isEditMode}
        selectedDevice={selectedDevice}
      />
    </ScrollView>
  );
};

DevicesSelection.propTypes = {
  onSelectDevicePress: PropTypes.func,
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      brand: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
      price: PropTypes.shape({
        upfront: PropTypes.number,
        currency: PropTypes.string,
        recurringCharge: PropTypes.number,
      }).isRequired,
      isRecommended: PropTypes.bool,
    }),
  ),
  isLoading: PropTypes.bool,
  isEditMode: PropTypes.bool,
  selectedDevice: PropTypes.shape({
    id: PropTypes.string,
    brand: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
    price: PropTypes.shape({
      upfront: PropTypes.number,
      currency: PropTypes.string,
      recurringCharge: PropTypes.number,
    }).isRequired,
    isRecommended: PropTypes.bool,
  }),
};

export default DevicesSelection;
